/*
 * usePhoneLayout: whether the console is drawn in its phone layout.
 *
 * Below 600 px wide the console trades its sidebar for a phone's frame: the
 * box picker and Ask Ada in the header bar, the places people go on a phone
 * in a bar at the foot (PhoneTabs), and every screen in a sheet behind More.
 * A screen that draws something too wide for a phone, the dashboard's network
 * drawing or the Trust Fabric's canvas, draws rows there instead.
 *
 * "Phone" elsewhere in the console means a phone in the fleet, the Android
 * client; this is the screen the console is read on. The stylesheets use the
 * same width (max-width: 599px), so the frame and its styles never disagree.
 */
import { useEffect, useState } from "react";

export const PHONE_QUERY = "(max-width: 599px)";

const narrow = () => typeof window !== "undefined" && !!window.matchMedia?.(PHONE_QUERY)?.matches;

export default function usePhoneLayout() {
  const [phone, setPhone] = useState(narrow);
  useEffect(() => {
    const query = window.matchMedia?.(PHONE_QUERY);
    if (!query?.addEventListener) return undefined;
    const update = () => setPhone(query.matches);
    update();
    query.addEventListener("change", update);
    return () => query.removeEventListener("change", update);
  }, []);
  return phone;
}
